import React from "react";
import { apiGetPengaturan, apiUpdatePengaturan, formatApiErrorDetail } from "@/lib/api";

// G1-F: public tracking name mask (owner decides before go-live; default off).
export default function PrivasiPanel() {
  const [nyala, setNyala] = React.useState(null);
  const [wajib, setWajib] = React.useState(null);
  const [tvNama, setTvNama] = React.useState(null);
  const [msg, setMsg] = React.useState(null);
  React.useEffect(() => {
    apiGetPengaturan().then((c) => { setNyala(!!c.tracking_samarkan_nama); setWajib(!!c.wajib_ganti_password); setTvNama(!!c.tv_nama_customer); }).catch(() => {});
  }, []);
  const ubah = async (v) => {
    setMsg(null);
    try {
      const c = await apiUpdatePengaturan({ tracking_samarkan_nama: v });
      setNyala(!!c.tracking_samarkan_nama);
      setMsg({ ok: true, text: v ? "Nama customer di tracking disamarkan." : "Nama lengkap customer tampil di tracking." });
    } catch (e) {
      setMsg({ ok: false, text: formatApiErrorDetail(e.response?.data?.detail) || e.message });
    }
  };
  // A3: "Wajib ganti password saat login pertama" (default off during the trial)
  const ubahWajib = async (v) => {
    if (v && !window.confirm("Nyalakan? Semua akun yang masih memakai password sementara (termasuk akun Anda bila belum pernah diganti) wajib mengganti password sebelum memakai aplikasi.")) return;
    setMsg(null);
    try {
      const c = await apiUpdatePengaturan({ wajib_ganti_password: v });
      setWajib(!!c.wajib_ganti_password);
      setMsg({ ok: true, text: v ? "Wajib ganti password: NYALA." : "Wajib ganti password: mati." });
    } catch (e) {
      setMsg({ ok: false, text: formatApiErrorDetail(e.response?.data?.detail) || e.message });
    }
  };
  // owner 2026-10-07: customer name on the shop TV (/tv opens without login)
  const ubahTv = async (v) => {
    setMsg(null);
    try {
      const c = await apiUpdatePengaturan({ tv_nama_customer: v });
      setTvNama(!!c.tv_nama_customer);
      setMsg({ ok: true, text: v ? "Layar TV menampilkan nama customer." : "Layar TV tanpa nama customer." });
    } catch (e) {
      setMsg({ ok: false, text: formatApiErrorDetail(e.response?.data?.detail) || e.message });
    }
  };
  if (nyala === null) return null;
  return (
    <div data-testid="privasi-panel" className="rounded-xl border border-slate-800 bg-slate-900/60 p-5 space-y-2">
      <h2 className="text-[15px] font-bold text-soq-biru-tua">Privasi & keamanan</h2>
      <label className="flex items-start gap-2 text-sm text-slate-200">
        <input type="checkbox" data-testid="privasi-samarkan" checked={nyala} onChange={(e) => ubah(e.target.checked)} className="mt-1" />
        <span>Samarkan nama di tracking <span className="block text-xs text-slate-500">Nyala: tracking publik menampilkan "B*** S***". Mati (default selama uji coba): nama lengkap. Nota digital, halaman cek status, dan halaman ACC selalu menampilkan nama lengkap (link pribadi customer). Nomor HP tidak pernah tampil.</span></span>
      </label>
      <label className="flex items-start gap-2 text-sm text-slate-200">
        <input type="checkbox" data-testid="keamanan-wajib-ganti" checked={!!wajib} onChange={(e) => ubahWajib(e.target.checked)} className="mt-1" />
        <span>Wajib ganti password saat login pertama <span className="block text-xs text-slate-500">Mati (default selama uji coba): akun baru / yang direset bisa langsung dipakai dengan password sementara. Nyala: akun dengan password sementara harus menggantinya dulu. Diputuskan Owner sebelum go-live.</span></span>
      </label>
      <label className="flex items-start gap-2 text-sm text-slate-200">
        <input type="checkbox" data-testid="privasi-tv-nama" checked={!!tvNama} onChange={(e) => ubahTv(e.target.checked)} className="mt-1" />
        <span>Tampilkan nama customer di layar TV <span className="block text-xs text-slate-500">Nyala (keputusan owner): kartu di layar TV (/tv) menampilkan nama lengkap customer dan nama tim Jersey. Layar TV dibuka tanpa login, dikunci kode akses TV (menu Monitoring → Layar produksi & kode TV). Nama pemain, PIC, nomor HP, dan harga tidak pernah tampil.</span></span>
      </label>
      {msg && <p className={`text-xs ${msg.ok ? "text-emerald-300" : "text-red-300"}`}>{msg.text}</p>}
    </div>
  );
}
